import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is Pas

export const Viscosity: BaseQuantity = {
  id: "001Viscosity",
  name: "viscosity",
  type: "numeric",
  value: "",
  symbol: "\u03BC",
  baseUnit: "Pa\u00B7s",
  selectedUnit: "Pa\u00B7s",
  units: [
    { name: "Pa\u00B7s", fromConst: 1, toConst: 1 },
    { name: "N\u00B7s/m\u00b2", fromConst: 1, toConst: 1 },
    { name: "kg/ms", fromConst: 1, toConst: 1 },
  ],
};

// Kinematic viscosity is defined as
// kinematic_viscosity = viscosity / density
// the unit is m2/s or Nms/kg or Js/kg
